import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FeatureFlagsModule } from '@libraries/feature-flags';

@NgModule({
  imports: [CommonModule, FeatureFlagsModule],
})
export class AssetsModule {}
